import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text } from '@ui-kitten/components';
import { StyleSheet, ScrollView, RefreshControl, BackHandler, View } from 'react-native';
import { StatusBar } from 'expo-status-bar';

import {TopBar} from './topBar.js'
import {Tasks} from './tasks.js'
import {InfoCards} from './cards.js'
import {News} from './news.js'
import { useFocusEffect } from '@react-navigation/native';

import moment from 'jalali-moment'

const month = ['فروردین','اردیبهشت','خرداد','تیر','مرداد','شهریور','مهر','آبان','آذر','دی','بهمن','اسفند'];
export const HomeScreen = () => {
  const [refreshing, setRefreshing] = useState(true);
  useFocusEffect(
    React.useCallback(() => {
      const onBackPress = () => {
        console.log('back pressed!');
        BackHandler.exitApp()
        return true
      };
      const subscription = BackHandler.addEventListener('hardwareBackPress', onBackPress);
      return () => subscription.remove();
    }, [])
  );
  const onRefresh = () => {
    //Clear old data of the list
    console.log('refreshing');
    //Call the Service to get the latest data

  };
  return (
      <Layout level='2' style={styles.container}>
        <TopBar />
        <Layout level='2' style={{flex:1, borderTopRightRadius:20, borderTopLeftRadius:20}}>
          <View style={{flexDirection:'row', justifyContent:'space-between',height:25, paddingHorizontal:10, borderTopRightRadius:20,  borderTopLeftRadius:20 }} />

          <ScrollView>
            <InfoCards />
            <Layout  level='2' style={{flexDirection:'row', justifyContent:'flex-start', alignItems:'center', paddingHorizontal:10,marginVertical:5}}>
              <Text category='c2' appearance='hint'>خبرها و اطلاعیه‌های روز</Text>
              <Divider style={{flex: 1, marginHorizontal: 10}}/>
            </Layout>
            <News />
            <Layout  level='2' style={{flexDirection:'row', justifyContent:'flex-start', alignItems:'center', paddingHorizontal:10,marginTop:5}}>
              <Text category='c2' appearance='hint'>کارهای تخصیص یافته</Text>
              <Divider style={{flex: 1, marginHorizontal: 10}}/>
            </Layout>
            <Tasks />
          </ScrollView>
        </Layout>
        <StatusBar style="light" />
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    backgroundColor:'#134A93',

  },
});
